import React, { lazy, Suspense, useState, useEffect } from "react";
import { LazyMotion, domAnimation, MotionConfig } from "motion/react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import Footer from "./components/Footer";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import "./App.css";
import "./components/Layout/Portfolio.css";

const About = lazy(() => import("./components/About/About"));
const Projects = lazy(() => import("./components/Projects/Projects"));
const Resume = lazy(() => import("./components/Resume/ResumeNew"));
const Experience = lazy(() => import("./components/Experience/Experience"));

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <LazyMotion features={domAnimation}>
      <MotionConfig reducedMotion="user">
        <Router future={{ v7_relativeSplatPath: true }}>
          <Preloader load={load} />
          <div className="App" id={load ? "no-scroll" : "scroll"}>
            <Navbar />
            <ScrollToTop />
            <Suspense
              fallback={
                <div className="route-loading" role="status">
                  Loading page…
                </div>
              }
            >
              <Routes>
                <Route path="/" element={<Home ready={!load} />} />
                <Route path="/about" element={<About />} />
                <Route path="/experience" element={<Experience />} />
                <Route path="/project" element={<Projects />} />
                <Route path="/resume" element={<Resume />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Suspense>
            <Footer />
          </div>
        </Router>
      </MotionConfig>
    </LazyMotion>
  );
}

export default App;
